module.exports = __webpack_public_path__ + "media/palenque/shade_waterfall-cd6390bf.jpg";